/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { getRouteCarForTotalTime } from "../../../actions/navitimeAPI";
import moment from "moment";
import AdminInputLocation from "../components/AdminInputLocation";
import AdminInputDatePicker from "../components/AdminInputDatePicker";
import AdminCheckbox from "../components/AdminCheckbox";
import Select, { components } from "react-select";
import { travelAreaOptionsEnglish } from "../../../utils/dataLists";
import AdminInputTimePicker from "../components/AdminInputTimePicker";
import AdminInputPassengers from "../components/AdminInputPassengers";
import AdminInputLuggage from "../components/AdminInputLuggage";
import AdminInput from "../components/AdminInput";
import AdminSelect from "../components/AdminSelect";
import { LuggageIcon, CalendarAltIcon, PaxIcon, TravelAreaIcon, LocationPinIcon, ClockIcon } from "../../icons";

export const ByTheHourQuotation = ({ searchAvailableVehicles, editFormAV = null }) => {

  const [halfHourIntervalsData, setHalfHourIntervalsData] = useState([]);

  const [byTheHourForm, setByTheHourForm] = useState({
    pickupLocation: null,
    dropoffLocations: [],
    usageDuration: null,
    travelDate: null,
    pickupTimeRaw: null,
    estpPickupTime: null,
    travelArea: null,
    luggage: {
      cabinSize: 0,
      checkinSize: 0,
    },
    pax: {
      adult: 0,
      child: 0,
      toddler: 0,
      baby: 0,
    },
    byTheHourBook: true,
    bookingType: "byTheHour",
    isAirportTransfer: false,
    isFromAirport: false,
    isToAirport: false,
    isStationTransfer: false,
    isFromStation: false,
    isToStation: false,
    fromQuotation: true,
    longDistance: false,
    totalDistance: 0,
    driverAccomodation: false
  });

  const [undecidedPickupChecked, setUndecidedPickupChecked] = useState(false);
  const [undecidedDropoffChecked, setUndecidedDropoffChecked] = useState(false);

  useEffect(() => {
    if (editFormAV != null) {
      let editFormData = { ...editFormAV, usageDuration: editFormAV.duration, fromQuotation: true }

      if (!editFormAV?.pickupLocation) {
        editFormData.pickupLocation = null;
        setUndecidedPickupChecked(!undecidedPickupChecked)
      }

      if (editFormAV?.dropoffLocations?.length === 0) {
        editFormData.dropoffLocations = [];
        setUndecidedDropoffChecked(!undecidedPickupChecked)
      }

      setByTheHourForm(editFormData);
    }
  }, [editFormAV])

  const handleByTheHourPickupLocation = (location) => {
    if (location === undefined) return;

    const level1 = location.address_components.find(c => c.types.includes("administrative_area_level_1"));

    const city = level1?.long_name || null;
    location.lat = location.geometry.location.lat;
    location.lon = location.geometry.location.lng;
    location.label = location.name + ", " + location.formatted_address;
    location.formatted_address = location.name + ", " + location.formatted_address;
    location.value = location.place_id;
    location.description = location.description
    location.city = city;
    location.prefecture = city;
    setByTheHourForm({ ...byTheHourForm, pickupLocation: location });
  };

  const handleByTheHourDropOffLocation = (location) => {
    if (location === undefined) return;

    const level1 = location.address_components.find(c => c.types.includes("administrative_area_level_1"));

    const city = level1?.long_name || null;
    location.lat = location.geometry.location.lat;
    location.lon = location.geometry.location.lng;
    location.label = location.name + ", " + location.formatted_address;
    location.formatted_address = location.name + ", " + location.formatted_address;
    location.value = location.place_id;
    location.description = location.description
    location.city = city;
    location.prefecture = city;
    setByTheHourForm({ ...byTheHourForm, dropoffLocations: [location] });
  };

  const handleBytheHourTravelDate = (date) => {
    const formattedDate = moment(date).local().format("YYYY-MM-DD");
    setByTheHourForm({ ...byTheHourForm, travelDate: formattedDate });
  };

  const handleBytheHourPickupTime = (time) => {
    const formattedTime = moment(time).local().format("HH:mm");
    setByTheHourForm({ ...byTheHourForm, pickupTimeRaw: formattedTime });
  };

  const handleOnChangeUsageDuration = (selectedOption) => {
    setByTheHourForm({ ...byTheHourForm, usageDuration: selectedOption.value });
  };

  const handleOnChangeTravelArea = (selectedOption) => {
    setByTheHourForm({ ...byTheHourForm, travelArea: selectedOption.value });
  };

  const handleOnChangeLuggage = (luggage, amount) => {
    setByTheHourForm((prevForm) => {
      const newLugage = { ...prevForm.luggage };

      if (luggage === "cabin") {
        newLugage.cabinSize = Math.max(0, newLugage.cabinSize + amount);
      } else if (luggage === "checkin") {
        newLugage.checkinSize = Math.max(0, newLugage.checkinSize + amount);
      }

      return {
        ...prevForm,
        luggage: newLugage,
      };
    });
  };

  const handleOnChangePax = (pax, amount) => {
    setByTheHourForm((prevForm) => {
      const newPax = { ...prevForm.pax };

      if (pax === "adult") {
        newPax.adult = Math.max(0, newPax.adult + amount);
      } else if (pax === "child") {
        newPax.child = Math.max(0, newPax.child + amount);
      } else if (pax === "toddler") {
        newPax.toddler = Math.max(0, newPax.toddler + amount);
      } else if (pax === "baby") {
        newPax.baby = Math.max(0, newPax.baby + amount);
      }

      return {
        ...prevForm,
        pax: newPax,
      };
    });
  };

  const checkTotalTime = async (sfd) => {
    const start =
      sfd?.pickupLocation?.lat +
      "%2C" +
      sfd?.pickupLocation?.lon;
    const end =
      sfd?.dropoffLocations[0]?.lat +
      "%2C" +
      sfd?.dropoffLocations[0]?.lon;

    const car_r = await getRouteCarForTotalTime(start, end);



    const { total_time } = getSelectedRouteData(car_r);

    populateDurationSelect(total_time);
  };

  /**
   * * Get the selected route's data
   * @param total_time - return parameter - total time in minutes
   */
  const getSelectedRouteData = (car_r) => {
    const summary_arr = car_r[car_r.length - 1]?.summary;

    const total_time = summary_arr?.move?.time;

    return {
      total_time,
    };
  };

  function populateDurationSelect(minimal_duration) {
    setHalfHourIntervalsData([]);
    const start_from = Math.round(minimal_duration / 30);
    const halfHourIntervals = Array.from({ length: 49 }, (_, i) => {
      const hours = Math.floor(i / 2);
      const minutes = (i % 2) * 30;
      const time = `${hours.toString().padStart(2, "0")}:${minutes
        .toString()
        .padStart(2, "0")}`;
      const label = `${hours.toString().padStart(2, "0")} Hours ${minutes
        .toString()
        .padStart(2, "0")} Minutes`;

      return {
        value: time,
        label: label,
      };
    });
    const final_hour_data = halfHourIntervals.slice(start_from + 2);
    setHalfHourIntervalsData(final_hour_data);
  }

  useEffect(() => {
    if (
      byTheHourForm.pickupLocation === null &&
      byTheHourForm.dropoffLocations === null &&
      byTheHourForm.dropoffLocations.length === 0
    ) return;

    checkTotalTime(byTheHourForm);

    const { check, pickupStatus, dropoffStatus, dropoffType, pickupType } = checkIsAirportOrStation(
      byTheHourForm.pickupLocation,
      byTheHourForm.dropoffLocations
    );

    if (check) {
      if (dropoffType === "airport" || pickupType === "airport" || dropoffType === "station" || pickupType === "station") {
        setByTheHourForm(prev => ({
          ...prev,
          isAirportTransfer: dropoffType === "airport" || pickupType === "airport",
          isFromAirport: (pickupStatus && pickupType === "airport" ? true : false),
          isToAirport: (dropoffStatus && dropoffType === "airport" ? true : false),
          isStationTransfer: dropoffType === "station" || pickupType === "station",
          isFromStation: (pickupStatus && pickupType === "station" ? true : false),
          isToStation: (dropoffStatus && dropoffType === "station" ? true : false)
        }));
      }
    } else {
      setByTheHourForm(prev => ({
        ...prev,
        isAirportTransfer: false,
        isFromAirport: false,
        isToAirport: false,
        isStationTransfer: false,
        isFromStation: false,
        isToStation: false
      }));
    }
  }, [byTheHourForm.pickupLocation, byTheHourForm.dropoffLocations]);

  useEffect(() => {
    if (byTheHourForm?.estpPickupTime != null || byTheHourForm?.pickupTimeRaw != null) {
      const est = estimateTimeToDestinationWithDuration(byTheHourForm);
      setByTheHourForm({ ...byTheHourForm, estpPickupTime: est ?? "" });
    }

  }, [byTheHourForm.estpPickupTime, byTheHourForm.pickupTimeRaw]);

  // ! END OF  BY THE HOUR DATA

  const checkIsAirportOrStation = (pickupLocation, dropoffLocations) => {
    const AIRPORT_KEYWORDS = ["airport", "空港"];
    const STATION_KEYWORDS = ["station", "駅"];

    const AIRPORT_NAMES = ["haneda", "羽田", "narita", "成田", "kansai", "関西", "itami", "伊丹", "chubu", "chubu centrair", "中部国際"];
    const STATION_NAMES = ["tokyo", "東京", "shinjuku", "新宿", "shinagawa", "品川"];

    const isMatchingPlace = (location, typeKeywords, nameKeywords) => {
      if (!location || !location.formatted_address || !location.types) return { isMatch: false, type: "none" };

      const typesLower = location.types.map(t => t.toLowerCase());
      const addressParts = location.formatted_address.toLowerCase().split(",");

      if (typesLower.includes("airport") || typesLower.includes("train_station") || typesLower.includes("subway_station")) {
        // Check for matching type and address parts
        for (let i = 0; i < addressParts.length; i++) {
          for (let keyword of typeKeywords) {
            for (let name of nameKeywords) {
              if (
                addressParts[i].includes(name) &&
                addressParts[i].includes(keyword)
              ) {
                return { isMatch: true, type: keyword === "airport" || keyword === "空港" ? "airport" : "station" };
              }
            }
          }
        }
      }

      // // Fallback: if location.types directly includes one of the types
      // if (typesLower.includes("airport")) return { isMatch: true, type: "airport" };
      // if (typesLower.includes("train_station") || typesLower.includes("subway_station")) return { isMatch: true, type: "station" };

      return { isMatch: false, type: "none" };
    };

    const pickup = isMatchingPlace(pickupLocation, [...AIRPORT_KEYWORDS, ...STATION_KEYWORDS], [...AIRPORT_NAMES, ...STATION_NAMES]);
    const dropoffLoc = dropoffLocations?.[dropoffLocations.length - 1];
    const dropoff = isMatchingPlace(dropoffLoc, [...AIRPORT_KEYWORDS, ...STATION_KEYWORDS], [...AIRPORT_NAMES, ...STATION_NAMES]);

    return {
      check: pickup.isMatch || dropoff.isMatch,
      pickupStatus: pickup.isMatch,
      dropoffStatus: dropoff.isMatch,
      pickupType: pickup.type,
      dropoffType: dropoff.type
    };
  };

  /**
   * * Function to get minimal duration count by the selected pickuplocation and dropofflocation and paste to drop off time as final estimation dropoff time of customer. Fire when both pickup location, dropoff location, and pickup time is filled.
   * ? sfd - Selected Form Data
   * ? timeString - pickup time in string 'HH:MM'
   * @param sfd
   * @param timeString - not required
   * @param duration - selected duration
   */
  const estimateTimeToDestinationWithDuration = (sfd, timeString) => {
    const pickupTime = moment(sfd.pickupTimeRaw, 'HH:mm').format('HH:mm');
    const duration = sfd.usageDuration;

    if (
      pickupTime === "" ||
      pickupTime == null ||
      duration === "" ||
      duration == null
    ) {
      return "N/A";
    }

    const timeToAdd = timeString === undefined ? pickupTime : timeString;

    const [hours, minutes] = timeToAdd.split(":").map(Number);
    const [hoursDuration, minutesDuration] = duration.split(":").map(Number);
    const totalMinutes = hours * 60 + minutes;

    const totalDurations = hoursDuration * 60 + minutesDuration;

    const newTotalMinutes = (totalMinutes + totalDurations) % (24 * 60);
    const newHours = Math.floor(newTotalMinutes / 60);
    const newMinutes = newTotalMinutes % 60;

    return `${String(newHours).padStart(2, "0")}:${String(newMinutes).padStart(
      2,
      "0"
    )}`;
  };


  useEffect(() => {
    if (
      (undecidedPickupChecked || byTheHourForm.pickupLocation != null) &&
      (undecidedDropoffChecked || byTheHourForm.dropoffLocations != null) &&
      (undecidedDropoffChecked || byTheHourForm.dropoffLocations.length > 0) &&
      byTheHourForm.usageDuration != null &&
      byTheHourForm.travelDate != null &&
      byTheHourForm.pickupTimeRaw != null &&
      byTheHourForm.estpPickupTime != null &&
      byTheHourForm.travelArea != null &&
      Object.values(byTheHourForm.pax).some(paxCount => paxCount > 0)
    ) {
      searchAvailableVehicles(byTheHourForm);
    }
  }, [byTheHourForm])


  const UsageDurationSelectComponent = ({ children, ...props }) => {
    return (
      components.ValueContainer && (
        <components.ValueContainer {...props}>
          {!!children && (

            <ClockIcon
              style={{ position: 'absolute', left: 8, paddingLeft: 8 }} />
          )}
          {children}
        </components.ValueContainer>
      )
    );
  };


  const TravelAreaSelectComponent = ({ children, ...props }) => {
    return (
      components.ValueContainer && (
        <components.ValueContainer {...props}>
          {!!children && (
            <TravelAreaIcon
              style={{ position: 'absolute', left: 8, paddingLeft: 8 }} />
          )}
          {children}
        </components.ValueContainer>
      )
    );
  };


  const styles = {
    valueContainer: base => ({
      ...base,
      paddingLeft: 43
    })
  }

  const getTimeFormat = (timeRaw) => {
    const [hours, minutes] = timeRaw.split(":").map(Number);

    // Create a new Date object for today with the specified time
    const date = new Date();
    date.setHours(hours, minutes, 0, 0); // Set the time, keep the date as today
    return date
  }

  const onCheckedUndecided = (e) => {
    if (e.target.name === "undecidedPickup") {
      setUndecidedPickupChecked(!undecidedPickupChecked)
      setByTheHourForm({ ...byTheHourForm, pickupLocation: null });
    }
    if (e.target.name === "undecidedDropoff") {
      setUndecidedDropoffChecked(!undecidedDropoffChecked)
      setByTheHourForm({ ...byTheHourForm, dropoffLocations: [] });
    }
  }

  useEffect(() => {
    if (!undecidedDropoffChecked && !undecidedPickupChecked) {
      setHalfHourIntervalsData([]);
    } else if (undecidedDropoffChecked || undecidedPickupChecked) {
      populateDurationSelect(0);
    }

  }, [undecidedDropoffChecked, undecidedPickupChecked])

  const handleOnChangeLongDistance = () => {
    setByTheHourForm(prev => ({
      ...prev,
      longDistance: !prev.longDistance,
      totalDistance: 0
    }));
  }

  const handleOnChangeTotalDistance = (e) => {
    setByTheHourForm(prev => ({
      ...prev,
      totalDistance: e.target.value
    }));
  }

  const handleOnChangeDriverAccomodation = () => {
    setByTheHourForm(prev => ({
      ...prev,
      driverAccomodation: !prev.driverAccomodation,
    }));
  }

  return (
    <div className="">
      <div className="row mb-2">
        <div className="col-6">
          <AdminInputLocation
            prefixIcon={<LocationPinIcon />}
            placeholder={undecidedPickupChecked ? "Pick-up: Undecided" : "Pick-up: Airport, Hotel, Attraction, etc"}
            onSelectLocation={handleByTheHourPickupLocation}
            mb="mb-2"
            label={"Pick-up"}
            value={byTheHourForm?.pickupLocation?.formatted_address}
            disabled={undecidedPickupChecked}
          />
          <AdminCheckbox
            label={"Undecided"}
            checked={undecidedPickupChecked}
            mt="mt-1 mb-2"
            disabled={false}
            onChange={(e) => onCheckedUndecided(e)}
            name={"undecidedPickup"}
          />
        </div>
        <div className="col-6">
          <AdminInputLocation
            prefixIcon={<LocationPinIcon />}
            placeholder={undecidedDropoffChecked ? "Drop-off: Undecided" : "Drop-off: Airport, Hotel, Attraction, etc."}
            onSelectLocation={handleByTheHourDropOffLocation}
            mb="mb-2"
            label={"Drop-off"}
            value={byTheHourForm?.dropoffLocations[byTheHourForm?.dropoffLocations.length - 1]?.formatted_address}
            disabled={undecidedDropoffChecked}
          />
          <AdminCheckbox
            label={"Undecided"}
            checked={undecidedDropoffChecked}
            mt="mt-1 mb-2"
            disabled={false}
            onChange={(e) => onCheckedUndecided(e)}
            name={"undecidedDropoff"}
          />
        </div>
      </div>
      <div className="row mb-2">
        <div className="col-3">
          <AdminInputDatePicker
            label={"Travel Date"}
            placeholder="Select travel date"
            prefixIcon={<CalendarAltIcon />}
            onSelectDate={handleBytheHourTravelDate}
            mb={""}
            name="travelDate"
            value={byTheHourForm.travelDate != null ? moment(byTheHourForm.travelDate, "YYYY-MM-DD").toDate() : null}
            dateFormat="MMMM d, yyyy"
          />
        </div>
        <div className="col-3">
          <AdminSelect
            label="Usage Duration"
            placeholder="Usage Duration"
            prefixIcon={<ClockIcon/>}
            options={halfHourIntervalsData}
            onChange={handleOnChangeUsageDuration}
            mb="mb-0"
            value={byTheHourForm.usageDuration
              ? halfHourIntervalsData.find(option => option.value === byTheHourForm.usageDuration) ?? null
              : null
            }
          />
        </div>
        <div className="col-3">
          <AdminSelect
            label="Travel Area"
            placeholder="Travel Area"
            prefixIcon={<TravelAreaIcon/>}
            options={travelAreaOptionsEnglish}
            onChange={handleOnChangeTravelArea}
            mb="mb-0"
            value={byTheHourForm.travelArea && {
              label: travelAreaOptionsEnglish.find(option => option.value === byTheHourForm.travelArea)?.label,
              value: byTheHourForm.travelArea,
            }}
          />
        </div>
        <div className="col-3">
          <AdminInputTimePicker
            label={"Pick-up Time"}
            placeholder="Select Pick-up Time"
            prefixIcon={<CalendarAltIcon />}
            onSelectDate={handleBytheHourPickupTime}
            name="travelDate"
            mb="mb-0"
            value={byTheHourForm.pickupTimeRaw != null ? getTimeFormat(byTheHourForm.pickupTimeRaw) : null}
          />
          <p className="tw:!text-[13px] tw:!mt-1 tw:!mb-0 tw:!text-[#8D8D8D]">
            Est. Drop-off Time:{" "}
            <span className="tw:!text-[13px] tw:!mt-1 tw:!mb-0 tw:!text-[#8D8D8D]">
              {byTheHourForm.estpPickupTime ?? ""}
            </span>
          </p>
        </div>
      </div>
      <div className="row mb-2">
        <div className="col-3">
          <AdminInputPassengers
            label={"Passenger"}
            placeholder="Input Passenger"
            prefixIcon={<PaxIcon />}
            totalAdult={byTheHourForm.pax.adult}
            totalBaby={byTheHourForm.pax.baby}
            totalToddler={byTheHourForm.pax.toddler}
            totalChild={byTheHourForm.pax.child}
            onChange={handleOnChangePax}
            value={
              byTheHourForm.pax.adult +
              byTheHourForm.pax.child +
              byTheHourForm.pax.toddler +
              byTheHourForm.pax.baby
            }
          />
        </div>
        <div className="col-3">
          <AdminInputLuggage
            label={"Luggage"}
            placeholder="Input Luggage"

            prefixIcon={<LuggageIcon />}
            totalCabin={byTheHourForm.luggage.cabinSize}
            totalCheckin={byTheHourForm.luggage.checkinSize}
            onChange={handleOnChangeLuggage}
            value={
              byTheHourForm.luggage.cabinSize + byTheHourForm.luggage.checkinSize
            }
          />
        </div>
        <div className="col-3">
          <AdminInput
            mt={"mb-0"}
            placeholder={"Total Distance (Km)"}
            label={"Total Distance (Km)"}
            onChange={handleOnChangeTotalDistance}
            disable={!byTheHourForm.longDistance}
            value={byTheHourForm.totalDistance}
            name="totalDistance"
            type="number"
          />
          <AdminCheckbox
            mt={"mt-0 mb-2"}
            label={"Long Distance Needed"}
            onChange={handleOnChangeLongDistance}
            disabled={false}
            checked={byTheHourForm.longDistance}
            name="longDistance"
          />
        </div>
        <div className="col-3">
          <AdminCheckbox
            mt={"mt-4 pt-2"}
            label={"Driver's Accomodation"}
            onChange={handleOnChangeDriverAccomodation}
            disabled={false}
            checked={byTheHourForm.driverAccomodation}
            name="driversAccomodation"
          />
        </div>
      </div>
      <div className="row mb-2">

      </div>
    </div>
  );
};
